export default {
  data () {
    return {
      hiddenPeriods: ['current_year', 'historic'],
      notAccountableFilters: [
        'status.code',
        'customCategory.id',
        'receipt.accountingDate[after]',
        'date[after]',
        'amountEqualZero',
        'amountDistinctZero',
        'accountingPeriodId',
        'type.code',
        'reviewStatus.code',
        'imOwnerOfBudget'
      ],
      referenceDate: 'createdAt'
    }
  },
  computed: {
    currentTransactionFilters () {
      return this.$store.getters['TransactionsStore/filters']
    },
    filtersAmount () {
      return this.$store.getters['TransactionsStore/userSelectedFiltersAmount']
    }
  },
  methods: {
    emitResetFilters () {
      this.$emit('resetFilters')
    },
    showFilterModal () {
      this.$emit('showTransactionFiltersModal')
    },
    setField (field, value) {
      this[field] = value
      if (field !== 'maxDate' && field !== 'minDate') {
        this.showEmailField = false
      }
    },
    setDate (event) {
      this.exportDateRange = event.filter
      this.minDate = this.exportDateRange['date[after]']
      this.maxDate = this.exportDateRange['date[before]']
    }
  }
}
